// extracted by mini-css-extract-plugin
module.exports = {"item":"autocomplete_entity_item-module__item--2e90r","selected":"autocomplete_entity_item-module__selected--2-Gzq","label":"autocomplete_entity_item-module__label--3HRoP"};